import React from 'react';
import { Link, useNavigate } from "react-router-dom";
import Avatar from '../components/Avatar';
import Button from '../components/Button';
import Text from '../components/Text';

function Aide(props) {
    return (
        <div className="w-home row w-fullscreen">
            <div className='col-lg-3 bg-blue w-half-left'>
                <Avatar
                    type="w-avatar-info"
                    nom="David"
                    mail="david.st@word.in"
                    worder="WOrder : 30"
                    src="/img/players/player_d.png"
                    classes="w-avatar-info"
                />
                <Link to="/partielettre">
                    <Button text="Nouvelle partie" classes="w-btn-white" />
                </Link>
                <Link to="/scorespartie">
                    <Button text="Voir les scores" classes="w-btn-white" />
                </Link>
                <Link to="/worders">
                    <Button text="Les WOrders (50)" classes="w-btn-white" />
                </Link>
                <Link to="/">
                    <Button text="Quitter" classes="w-text w-btn-gray" />
                </Link>
                <Link to="/aide">
                    <Text text="Besoin d'aide ?" classes="w-text-white-lg" />
                </Link>
            </div>
            <div className='col-lg-9 w-half-right'>
                <img className="w-img-lg" src="/img/categories/wordin_full.png" alt="home" />

                <Text classes="w-text-blue-title" text="A propos" /> 

                <Text text="L’émergence ici c’est l’émulsion, c’est pas l’immersion donc la
                    cosmogonisation à forciori, parvient à gérer la renaissance 
                    africaine off-shore, tu sais ça. Pour emphysiquer l'animalcul
                    isme, la délégation vers ce qu’on appelle la dynamique des s
                    ports continue à incristaliser une position axisienne vers l'h
                    umanisme, bonnes fêtes. Pour emphysiquer l'animalculisme
                    , la congolexicomatisation de toute la République Démocrati
                    que du Congo pousse à réglementer une kermesse dans la s
                    ous-régionalité, mais oui." classes="w-text-gray-paragraph m-5" />

                <Text classes="w-text-blue-title" text="Aide" /> 

                <Text text="L’émergence ici c’est l’émulsion, c’est pas l’immersion donc la
                    cosmogonisation à forciori, parvient à gérer la renaissance 
                    africaine off-shore, tu sais ça. Pour emphysiquer l'animalcul
                    isme, la délégation vers ce qu’on appelle la dynamique des s
                    ports continue à incristaliser une position axisienne vers l'h
                    umanisme, bonnes fêtes. Pour emphysiquer l'animalculisme
                    , la congolexicomatisation de toute la République Démocrati
                    que du Congo pousse à réglementer une kermesse dans la s
                    ous-régionalité, mais oui. " classes="w-text-gray-paragraph m-5" />

             </div>
        </div>
    );
}

export default Aide;